import React from "react"
import {action, observable} from "mobx"
import moment from "moment"
import Polyglot from "node-polyglot"
import en from "locales/en.json"
import de from "locales/de.json"
import app from "app.controller" // legacy
import store from "store"
import queryString from "querystring"

const translations = {
    en,
    de
}

window.translations = translations

// import _ from "lodash"

class LanguageStore {
    @observable currentLanguage = "de"
    @observable locale = "de"
    @observable messages = []
    @observable available = []

    constructor() {
        let availableLanguages = process.env.REACT_APP_LANG || ""
        availableLanguages = availableLanguages.split(",")
        const parsed = queryString.parse(document.location.search, {ignoreQueryPrefix: true})
        app._currentLanguage = parsed.lang || store.get("lang") || this.currentLanguage
        this.setLanguage(app._currentLanguage, {reload: false})
        availableLanguages.forEach(locale => this.load(locale))
    }

    load(locale) {
        this.available.push(locale)
        let APP_ID = process.env.REACT_APP_ID
        if (APP_ID) {
            fetch(`/locale/${locale}.json?random=${Math.random()}`)
                .then(res => res.json())
                .then((data) => this.addLanguage(locale, data))
                .catch(err => {
                    console.log(`no locale for  ${locale}`, err, `/locale/${APP_ID}.${locale}.json`)
                })
        }
    }

    addLanguage(locale, data) {
        let updated = Object.assign(translations[locale] || {}, data)
        translations[locale] = updated
        // this.setLanguage( locale, { reload: false } )
        if (this.locale === locale) {
            this.setLanguage(locale, {reload: false})
        }
    }

    supports(lang) {
        return !!translations[lang]
    }

    @action
    setLanguage(locale, {reload = true} = {}) {
        let polyglot
        let translateText
        let translation = {
            locale,
            warn: (err) => {
                // console.warn( err )
            },
            phrases: translations[locale]
        }
    

        moment.locale(locale)
        polyglot = new Polyglot(translation)
        window.polyglot = polyglot
        translateText = polyglot.t.bind(polyglot)
        store.set("lang", locale)

        function renderTranslatedText(textKey, ...rest) {
            return <span data-text-key={textKey} className="_i18n">{translateText(textKey, ...rest)}</span>
        } // Tired of importing it.
        window.translate = translateText
        this.translate = translateText
        this.translateText = translateText

        this.currentLanguage = locale
        this.locale = locale
        this.messages = translations[locale]
        app._currentLanguage = locale // legacy
        if (reload) document.location.reload()
    }
}

const languageStore = new LanguageStore()
window.languageStore = languageStore

export default languageStore
const translate = languageStore.translate
export {translate}



// WEBPACK FOOTER //
// ./src/stores/languageStore.js